import { Copil } from '@apps/pata/domain/models/copil';
import { createAction, props } from '@ngrx/store';

export const BackPataCopilsListRequested = createAction(
    '[PATA-COPILS] Back Pata Copils List Requested'
);
export const BackPataCopilsListSucceeded = createAction(
    '[PATA-COPILS] Back Pata Copils List Succeeded',
    props<{ copils: Copil[] }>()
);
export const BackPataCopilsListFailed = createAction(
    '[PATA-COPILS] Back Pata Copils List Failed'
);
export const BackPataCopilsListFilterTriggered = createAction(
    '[PATA-COPILS] Back Pata Copils List Filter Triggered',
    props<{ done: boolean }>()
);
export const BackPataCopilsQsWordSet = createAction(
    '[PATA-COPILS] Back Pata Copils QsWord Set',
    props<{ qsWord: string }>()
);